import Hero from "@/components/Hero";
import Seo from "@/components/Seo";
import EditorialMarquee from "@/components/EditorialMarquee";
import StatsStrip from "@/components/StatsStrip";
import Manifesto from "@/components/Manifesto";
import ServicesGrid from "@/components/ServicesGrid";
import SectorsSection from "@/components/SectorsSection";
import CitiesIndex from "@/components/CitiesIndex";
import Testimonials from "@/components/Testimonials";
import FaqSection from "@/components/FaqSection";
import QuoteForm from "@/components/QuoteForm";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Seo
        title="Maze Security Solutions · Licensed Security Guards in New Brunswick"
        description="Licensed uniformed guards, mobile patrol, event security, executive protection & 24/7 alarm response across every NB community. Est. 2008. Bilingual. Insured. Call (807) 907-2874."
        path="/"
      />
      <Hero />
      <EditorialMarquee />
      <StatsStrip />
      <ServicesGrid />
      <Manifesto />
      <SectorsSection />
      <CitiesIndex />
      <Testimonials />
      <FaqSection />
      <QuoteForm />
    </div>
  );
}
